import { render, staticRenderFns } from "./AncillariesModal.vue?vue&type=template&id=63a8173c&scoped=true"
import script from "./AncillariesModal.vue?vue&type=script&lang=js"
export * from "./AncillariesModal.vue?vue&type=script&lang=js"
import style0 from "./AncillariesModal.vue?vue&type=style&index=0&id=63a8173c&prod&lang=scss"
import style1 from "./AncillariesModal.vue?vue&type=style&index=1&id=63a8173c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8173c",
  null
  
)

export default component.exports